import { hashHistory } from 'react-router'
export default hashHistory



// WEBPACK FOOTER //
// ./src/components/layout/navigation/classes/History.js